export class PanVerificationScope {
  public static readonly PanOnly: string = "PanOnly";
  public static readonly PanWithOwnersName: string = "PanWithOwnersName";
  }
